import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../utils/helper';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../common/block-text/block-text.component';
import {
  WebPushInitModel,
  WebPushInitVariables,
  WebPushModel,
  WebPushVariables,
} from '../../../../models/web-push-template/web-push.interface';
import { NotificationComponent } from '../../common/notification/notification.component';
import { PinComponent } from '../../common/pin/pin.component';
import { BaseComponent } from '../../common/BaseComponent';
import { VariableMaxLengthService } from '../../../../services/variable-max-length.service';

@Component({
    selector: 'app-web-push',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './web-push.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './web-push.component.scss'
})
export class WebPushComponent extends BaseComponent implements OnInit {
  @Input() block: WebPushModel = new WebPushInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  count: number = 0;

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new WebPushInitVariables()
    }
  }

  //placeholders:
  webPushCopyPlaceHolder = "Enter copy text";
  webPushCtaPlaceHolder = "Enter CTA text";
  webPushImagePlaceHolder = "Image";
  webPushLinkPlaceHolder = "Enter link";
  webPushTitlePlaceHolder = "Enter title text";

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof WebPushVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
